import React from "react";
import { Container } from "../../core/Container/styled";

import * as S from "./styles";

export const InsightTitle = ({
  title,
  date,
  summary,
}: {
  title: string;
  date: string;
  summary: string;
}) => {
  const formattedDate = new Date(date).toLocaleDateString("en-GB");
  return (
    <S.Wrapper>
      <Container size="small">
        <S.Date>{formattedDate}</S.Date>
        <S.Heading>{title}</S.Heading>
        <S.Summary>{summary}</S.Summary>
      </Container>
    </S.Wrapper>
  );
};
